import React, { useState, useEffect } from 'react'
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button'
import { Divider, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles'
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(theme => ({
	container: {
        height: '450px',
        overflowY: 'hidden'
    },
    checkListContainer: {
        overflowY: 'scroll',
        height: '400px',
        marginTop: '15px',
        paddingBottom: '15px'
    },
    selectButton: {
        float: 'right'
    },
}))

export default function EmployeesColumnsSelect(props) {

    const classes = useStyles()
    
    const [columns, setColumns] = useState(props.columns)
    const [searchText, setSearchText] = useState('')



    useEffect(() => {
        setColumns(props.columns)
    }, [props.columns])

    return (
        <div className={classes.container}>
            <div>
                <TextField id="standard-search"label="Search field" InputProps={{
                    startAdornment: <SearchIcon/>
                    }} type="search" onChange={event => setSearchText(event.target.value)}>
                </TextField>
                <Button color="primary" className={classes.selectButton} onClick={props.hideAllColumns}>
                    Remove All
                </Button>
                <Button color="primary" className={classes.selectButton} onClick={props.showAllColumns}>
                    Select All
                </Button>
            </div>
            <Divider />
            <div className={classes.checkListContainer}>
                <FormGroup>
                    {columns.filter( col => col.title.toLowerCase().includes(searchText.toLowerCase())).map((column, index) => (
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox
                                    key={index}
                                    checked={!column.hidden}
                                    color="primary"
                                    onChange={() => props.onColumnHiddenChange(props.columns.indexOf(column), column.hidden)}
                                    value={column.title}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            }
                            label={column.title}
                        />
                    ))}
                </FormGroup>
            </div>
        </div>
    )
}